import { Grid } from '@mui/material';
import { cvtClassName } from 'commons/utils';

export const AppLogoHeader = () => {
  const headerClass = [
    'fixed',
    'top-0',
    'left-0',
    'w-full',
    'h-20',
    'text-[--c-text]',
    'bg-[--c-header-background]',
  ];

  const headerInnerClass = [
    'fixed',
    'top-5',
    'left-1/2',
    'w-full',
    'max-w-7xl',
    'mx-auto',
    'px-5',
    'items-center',
    'justify-between',
    '-translate-x-1/2',
  ];

  return (
    <div className="z-20 relative">
      <header className={cvtClassName(headerClass)}>
        <div className={cvtClassName(headerInnerClass)}>
          <Grid container direction="row" justifyContent="space-between" alignItems="center">
            <div className="grow-0 shrink basis-[150px]">
              <img src="/logo_spotu.png" alt="logo" role="img"></img>
            </div>
          </Grid>
        </div>
      </header>
    </div>
  );
};
